module.exports = __webpack_public_path__ + "static/media/teach.1a753fc8.jpg";